import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as queryString from 'query-string';

import AdminBar from '../../components/EventProfile/AdminBar';
import GenericPopup from '../../components/PopUps/GenericPopup';
import ProfileContent from '../../components/EventProfile/CreatePlay/Content';
import ProfileHeader from '../../components/EventProfile/CreatePlay/Header';
import ShareUrlPopupNew from '../../components/PopUps/ShareUrlPopup';
import { isLoginPopUpNeeded, userParams, titles } from '../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import head from '../../components/Meta';

import { acceptInvite, declineInvite } from '../../actions/event-actions';
import { getEventReferralURL, getEventShareURL } from '../../utils/referrals';
import { isOrganizer } from '../../utils/events';
import { showLoginPopUp } from '../../actions/login-popup-actions';
import config from '../../../config';

const CreatePlayProfilePage = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);
    const events = useSelector((state) => state.events);

    const { currentEvent = {} } = events;
    const { data: event } = currentEvent;
    const [showPlayerGroupModal, setShowPlayerGroupModal] = useState(false);
    const [showShareUrlPopup, setShowShareUrlPopup] = useState(false);
    const isCurrentMemberAdmin = event && isOrganizer(event);
    const currentMemberInvite = event && event.invites?.members.find(invite => invite.memberId === auth?.user?.id);
    // const eventInviteUrl = event && auth.user ? getEventReferralURL(event, auth.user) : getEventShareURL(event);
    const eventInviteUrl = getEventShareURL(event);
    const organizer = event?.eventDirectors[0]?.displayName;
    const modalText = `You are now a part of ${organizer}'s personal Player Group and they can invite you to future events directly on UTR Sports.`;
    const divisionId = event?.eventDivisions[0].id;
    const currentUserId = auth?.user?.id;
    const isUserLoggedIn = auth?.user;

    useEffect(() => {
        if (event && event.eventPermissionType?.id === 3 && !(currentMemberInvite || isCurrentMemberAdmin)) {
            history.push('/');
        }
    }, [auth.user, event, currentMemberInvite]);

    useEffect(() => {
        const state = { ...location.state };
        if (location?.state?.showSharePopup) {
            setShowShareUrlPopup(true);
            delete state.showSharePopup;
        }

        if (location?.state?.hasAccepted) {
            setShowPlayerGroupModal(true);
            delete state.hasAccepted;
        }

        history.replace({ ...location, state });

        showLoginModal();
    }, []);

    const showLoginModal = () => {
        const { shared } = queryString.parse(location.search);
        const userParamsNeeded = [userParams.CLAIMED_PROFILE];
        const isLoginPopupNeeded = isLoginPopUpNeeded(auth, userParamsNeeded);
        const popupData = {
            userParamsNeeded,
            titles: titles.EVENT_REGISTER,
            type: 'register',
        };
        if (isLoginPopupNeeded || (shared && !auth.user)) {
            dispatch(showLoginPopUp(popupData));
        }
    };

    const handleOnShowSharePopup = () => {
        if (isUserLoggedIn) {
            setShowShareUrlPopup(true);
        } else {
            showLoginModal();
        }
    };

    const handleOnRequestCloseShareModal = () => {
        setShowShareUrlPopup(false);
    };

    const handleOnLinkCopied = () => {
        if (window && window.analytics) {
            const path = '/share/event';
            const properties = {
                path,
                url: path,
                name: currentEvent.data.name,
            };

            window.analytics.page('share event profile', 'share link', properties);
        }
    };

    const handleOnPlayClicked = async () => {
        if (isUserLoggedIn) {
            await dispatch(acceptInvite(event.id, divisionId));
            setShowPlayerGroupModal(true);
        } else {
            showLoginModal();
        }
    };

    const handleOnPassClicked = async () => {
        if (isUserLoggedIn) {
            await dispatch(declineInvite(event.id, divisionId));
        } else {
            showLoginModal();
        }
    };

    const handleOnRequestModalClose = () => {
        setShowPlayerGroupModal(false);
    };

    return (
        <div>
            {head({
                title: event?.name ? `UTR Sports | ${event?.name}` : config.defaultTitle,
                description: event?.details,
                url: `${config.appHost}/events/${event?.id}`,
                keywords: 'UTR Sports events, Find UTR Sports tennis events, UTR post score',
                image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                imageWidth: '930',
                imageHeight: '395',
            })}
            {(event && !events.isLoading) && (
                <>
                    {isCurrentMemberAdmin &&
                        <AdminBar />}
                    <ProfileHeader
                        event={event}
                        currentUserId={currentUserId}
                        isCurrentMemberAdmin={isCurrentMemberAdmin}
                        showShareUrlPopup={handleOnShowSharePopup}
                        currentMemberInvite={currentMemberInvite}
                        onPlayClicked={handleOnPlayClicked}
                        onPassClicked={handleOnPassClicked}
                    />
                    <ProfileContent
                        isCurrentMemberAdmin={isCurrentMemberAdmin}
                    />
                    {showShareUrlPopup && (
                        <ShareUrlPopupNew
                            title={'Spread the word!'}
                            subtitle={'Copy and share the link with anyone'}
                            text={'Event Invite Link'}
                            url={`${eventInviteUrl}`}
                            hideButton={true}
                            isDraft={false}
                            closeBtnTxt={`Invite Club Members`}
                            onCloseClick={handleOnRequestCloseShareModal}
                            linkCopied={handleOnLinkCopied}
                        />
                    )}
                    {showPlayerGroupModal && (
                        <GenericPopup
                            subtitle={modalText}
                            buttonText="OK"
                            onRequestClose={handleOnRequestModalClose}
                            onButtonClick={handleOnRequestModalClose}
                            data-testid="modal.create-play-profile.player-group"
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default CreatePlayProfilePage;
